import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CandidateEntityModel } from "app/interfaces/candidate-entity.model";
import { TagsService } from "app/services";
import { FeatureFlagService } from "app/services/feature-flag.service";
import { FeatureFlags } from "feature-flags";

@Component({
  selector: "app-candidate-card",
  templateUrl: "./candidate-card.component.html",
  styleUrls: ["./candidate-card.component.scss"],
})
export class CandidateCardComponent implements OnInit {
  @Input() candidate!: CandidateEntityModel;
  @Input() isSelected!: boolean;
  @Input() canMessageSelection!: boolean;
  @Input() isExternal!: boolean;

  @Output() openDetail: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendMessageSelection: EventEmitter<any> = new EventEmitter<any>();
  @Output() addTag: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeTag: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeStatus: EventEmitter<any> = new EventEmitter<any>();
  @Output() changeProcessStatus: EventEmitter<any> = new EventEmitter<any>();

  public progress = 0;
  public value = null;

  public isScoreDisabledFF: boolean = this.ffs.isEnabled(FeatureFlags.DISABLE_SCORE) || false;

  get scoreEnabled(): boolean {
    return "user_score" in this.candidate;
  }

  get preferredLocationEnabled(): boolean {
    return "preferred_location" in this.candidate && this.candidate.preferred_location !== null;
  }

  constructor(private tagsService: TagsService, private ffs: FeatureFlagService) {
    this.ffs.unleash.on("update", () => {
      this.isScoreDisabledFF = this.ffs.isEnabled(FeatureFlags.DISABLE_SCORE);
    });
  }

  ngOnInit() {
    if (this.candidate.user_score && this.candidate.user_score > 0) {
      this.progress = 198 * (1 - this.candidate.user_score);
      this.value = Math.round(this.candidate.user_score * 100);
    }
  }

  emitOpenDetail() {
    this.openDetail.emit(this.candidate);
  }

  onTagClick(data: any) {
    this.tagsService
      .putCurriculaTagByApplicationId(this.candidate.id, {
        id: data.id,
        value: data.name,
      })
      .subscribe();
  }

  deleteTagService = async (args?) => await this._deleteTag(args);
  createTagService = async (args?) => await this._createTag(args);

  private async _deleteTag(args?) {
    await this.tagsService
      .deleteCurriculaTagByApplicationId(this.candidate.id, args)
      .toPromise();
    this.candidate.tags = await this.tagsService
      .getCurriculaTagsByApplicationId(this.candidate.id)
      .toPromise();
  }

  private async _createTag(args?) {
    await this.tagsService
      .putCurriculaTagByApplicationId(this.candidate.id, { value: args })
      .toPromise();
    this.candidate.tags = await this.tagsService
      .getCurriculaTagsByApplicationId(this.candidate.id)
      .toPromise();
  }

  emitChangeProcessStatus(processStatus: string) {
    this.changeProcessStatus.emit(processStatus);
  }
}
